import { render, staticRenderFns } from "./StampTab.vue?vue&type=template&id=09ef6325"
import script from "./StampTab.vue?vue&type=script&lang=js"
export * from "./StampTab.vue?vue&type=script&lang=js"
import style0 from "./StampTab.vue?vue&type=style&index=0&id=09ef6325&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports